import { css } from "@emotion/react";

export const TableHistoryMobileStyle = {
  wrapper: css`
    display: flex;
    flex-direction: column;
  `,

  loadingData: css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: white;

    span {
      margin-left: 5px;
    }
  `,

  emptyData: css`
    span {
      display: flex;
      justify-content: center;

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      padding: 31px 0 75px 0;
    }
  `,
};
